export type LatLngInput = {
  lat: number;
  lng: number;
};

export type NormalizedAddress = {
  city?: string;
  state?: string;
  zip?: string;
  label?: string;
};

export type BuildAddress = (
  address: NormalizedAddress,
  latLng?: LatLngInput
) => void;

export type SetLatLng = (latLng: LatLngInput, zip?: string) => void;